/**
 * User Management Screen
 * 
 * Main wrapper component that switches between desktop and mobile variants
 * based on screen size. Provides user management functionality for managers.
 * 
 * @module UserManagementScreen
 */

import React from 'react';
import { UserManagementScreenDesktop } from './UserManagementScreenDesktop';
import { UserManagementScreenMobile } from './UserManagementScreenMobile';

/**
 * User Management Screen Component
 * Responsive wrapper that renders appropriate variant based on screen size
 */
export const UserManagementScreen: React.FC = () => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Check on mount
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <UserManagementScreenMobile /> : <UserManagementScreenDesktop />;
};